import React from "react";

const LABELS = { guest: "Guest", free: "Free", starter: "Starter", pro: "Pro", founder: "Founder" };

export function PlanChip({ usage, className = "" }) {
  if (!usage) return null;
  const plan = usage.plan || "guest";
  const isPaid = usage.is_paid || plan === "founder";
  const remaining = usage.scans_remaining ?? usage.scans_remaining;
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide ${
        isPaid ? "bg-brand-soft text-brand" : "bg-canvas-alt text-ink-muted"
      } ${className}`}
      data-testid="plan-chip"
    >
      {LABELS[plan] || plan}
      {typeof remaining === "number" && !isPaid && (
        <span className="normal-case tracking-normal text-ink-subtle font-semibold">· {remaining} left</span>
      )}
    </span>
  );
}
